export default {
  valueType: 'dateRange',
  FormItemProps: {
    label: '日期区间',
    rules: [],
    style: {}
  },
  ControlProps: {
    disabled: false,
    placeholder: ["开始时间", "结束时间"],
    showTime: false,
    style: {}
  }
}